export const PermissionUrl = {
  SEARCH: '/permissions{?page,size,sort*,name,excludeIds}',
} as const;
